export default {"src":"/newStatic/_next/static/media/twitter.1621ee9e.svg","height":20,"width":20};